import React from "react";
import "./App.css";
import Root from "./pages/Root";
import ErrorBoundary from "./components/ErrorBoundary";
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

function App() {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const menuTheme = React.useMemo(
        () =>
            createTheme({
                palette: {
                    mode: prefersDarkMode ? 'dark' : 'light',
                    primary: {
                        main: '#EC407A',
                    }
                }
            }),
        [prefersDarkMode],
    );
    return (
        <ThemeProvider theme={menuTheme}>
            <CssBaseline/>
        <ErrorBoundary>
            <Root/>
        </ErrorBoundary>
        </ThemeProvider>
    );
}

export default App;